<template>
	<div class="flex justify-around flex-wrap">
		<div class="item flex flex-direction align-center" v-for="(item, index) in books" :key="index" @click="goDetail(item.id, item)">
			<img :src="item.image" alt="" />
			<span>{{ item.title }}</span>
		</div>
		<div class="item" v-if="books.length>1" v-for="(i, k) in leftFill(books.length, 2)" :key="'books_' + i"></div>
	</div>
</template>

<script>
export default {
	props: {
		books: [Array]
	},
	data() {
		return {};
	},
	methods: {
		goDetail(id, data = {}) {
			this.$emit('detail', { type: 'book',id: id, data: data });
		}
	}
};
</script>

<style lang="scss" scoped="">
.item {
	width: 2.4rem;
	margin-top: 0.2rem;
	margin-bottom: 0.2rem;
	
	img {
		width: 100%;
	}
	span {
		margin: 0.1rem 0;
		font-size: 0.28rem;
		color: #d2d2d2;
	}
}
</style>
